export default __webpack_public_path__ + "static/media/Edit.99fe6b78.svg";